const o="bottom-area",t="footer",a="footer-button-group",e="main-area",r="page-top",p="title-area",i="view-area";export{o as BOTTOM_AREA,t as FOOTER,a as FOOTER_BUTTON_GROUP,e as MAIN_AREA,r as PAGE_TOP,p as TITLE_AREA,i as VIEW_AREA};
